import { StockSymbol } from '@benzinga/session';
import { QuoteProtos } from './quotews_protos';

export type Security = StockSymbol;

export type DerivedQuote = {
  priceFormatted: string;
};

export type Quote = QuoteProtos.IQuote & Partial<DerivedQuote> & { symbol?: Security };

export const SessionType = QuoteProtos.SessionType;
